export const countries: { [key: string]: string } = {
  USA: 'USA',
  Canada: 'Canada',
  'United Kingdom': 'United Kingdom',
  Australia: 'Australia',
  France: 'France',
  Brazil: 'Brazil',
  India: 'India',
  Mexico: 'Mexico',
  Singapore: 'Singapore',
  'South Africa': 'South Africa',
}